import { JobRoleAccessTypeEnum } from '@/views/recruiter/job-role/models/enums'

export interface IRolesEntity {
  id: string
  name: string
  roleLevel: number
  isSystem: boolean
  updatedAt: string
  createdAt: string
}

export const RolesDisplayTitle = {
  COMPANY_INTERVIEWER: 'Hiring Manager / Interviewer',
  COMPANY_ADMIN: 'Super Admin',
  COMPANY_EMPLOYEE: 'Employee',
  COMPANY_RECRUITER: 'Recruiter',
  CANDIDATE: 'Candidate',
  AGENCY_USER: 'Agency User',
  INTERNAL_SUPER_ADMIN: 'Admin'
}

export const RolesToAccessType = {
  COMPANY_INTERVIEWER: JobRoleAccessTypeEnum.LIMITED_ACCESS,
  COMPANY_ADMIN: JobRoleAccessTypeEnum.FULL_ACCESS,
  COMPANY_EMPLOYEE: JobRoleAccessTypeEnum.EMPLOYEE
}

export enum RolesEnum {
  WC_SUPER_ADMIN = 'WC_SUPER_ADMIN',
  INTERNAL_SUPER_ADMIN = 'INTERNAL_SUPER_ADMIN',
  INTERNAL_WC_SALES = 'INTERNAL_WC_SALES',
  INTERNAL_PARTNER_SALES = 'INTERNAL_PARTNER_SALES',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  COMPANY_RECRUITER = 'COMPANY_RECRUITER', // TODO Still this role is not yet created
  COMPANY_INTERVIEWER = 'COMPANY_INTERVIEWER',
  COMPANY_EMPLOYEE = 'COMPANY_EMPLOYEE',
  CANDIDATE = 'CANDIDATE',
  AGENCY_USER = 'AGENCY_USER',
}

export enum CompanyRoleStatusEnum {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED'
}

export const roleLevels = {
  COMPANY_ADMIN: 2,
  COMPANY_RECRUITER: 3,
  COMPANY_INTERVIEWER: 4,
  CANDIDATE: 5,
  AGENCY_USER: 5,
  COMPANY_EMPLOYEE: 5
}
